export const COGNOS_BRIDGING_FACTORS = {
    COGNOS_AGL: { key: 'COGNOS_AGL', title: 'AGL' },
    COGNOS_AP_DEBIT_BALANCE_WO: { key: 'COGNOS_AP_DEBIT_BALANCE_WO', title: 'AP Debit Balance WO' } ,
    COGNOS_LOOSE_PICKING_CHARGES: { key: 'COGNOS_LOOSE_PICKING_CHARGES', title: 'Loose Picking Charges' },
    COGONS_QPD: { key: 'COGNOS_QPD', title: 'QPD' },
    COGNOS_RESERVES: { key: 'COGNOS_RESERVES', title: 'Cognos Reserves' },
    COGNOS_RETAIL_ONLY: { key: 'COGNOS_RETAIL_ONLY', title: 'Retail Only' },
    COGNOS_VENDOR_SERVICES_REVENUE: { key: 'COGNOS_VENDOR_SERVICES_REVENUE', title: 'Vendor Services Revenue' },
    COGNOS_WHD: { key: 'COGNOS_WHD', title: 'WHD' },
    COGNOS_OTHER_GROUPS: { key: 'COGNOS_OTHER_GROUPS', title: 'Other Groups' },
    COGNOS_TOTAL_VFCC_VNDR_SRVC: { key: 'COGNOS_TOTAL_VFCC_VNDR_SRVC', title: 'Total VFCC Vendor Services' },
};

export const HCP_COOP_BRIDGING_FACTORS = {
    TOTAL_COOP_AMOUNT: { key: 'TOTAL_COOP', title: 'Total COOP Amount' },
    CP_UNSIGNED: { key: 'CP_UNSIGNED', title: 'CP Unsigned' }
};


// WEBPACK FOOTER //
// ./src/components/reports/bridging/bridging_constants.jsx